<div class="card block isMinimizable">
    <div class="card-header">
        <div class="card-title">
            <i class="fa fa-angle-up"></i>
            <h2>Vérification des données</h2>
        </div>
    </div>
    <div class="card-body col-md-12">
        <img *ngIf="preview" src="assets/widgets/verif-data.png" class="img-fluid"/>
        <div class="card-text row" *ngIf="!preview">
            <div class="col-6">
                <mat-form-field>
                    <mat-label>Loyer
                        <ng-container *ngIf="favorite.lots.length > 1">total</ng-container>
                        mensuel HC
                        <i class="fa fa-exclamation-triangle" *ngIf="favorite.lots.length > 1"
                           matTooltip="Modifier le loyer par lot ci dessous"></i>
                        <i class="fa fa-info-circle" *ngIf="favorite.lots.length == 1"
                           matTooltip="Le montant du loyer mensuel sans les charges locatives."></i>
                    </mat-label>
                    <input type="number" step="100" matInput [(ngModel)]="favorite.amount_rent"
                           (ngModelChange)="edit($event, 'amount_rent')"
                           [disabled]="favorite.lots.length > 1">
                    <span matSuffix>€/mois</span>
                </mat-form-field>
            </div>

            <div class="col-6">
                <mat-form-field>
                    <mat-label>Loyer
                        <ng-container *ngIf="favorite.lots.length > 1">total</ng-container>
                        annuel HC <i class="fa fa-exclamation-triangle" *ngIf="favorite.lots.length > 1"
                                     matTooltip="Modifier le loyer par lot dans l'onglets Rendement"></i></mat-label>
                    <input type="number" step="100" matInput [(ngModel)]="amount_rent_year"
                           (ngModelChange)="edit($event, 'amount_rent_year')"
                           [disabled]="favorite.lots.length > 1">
                    <span matSuffix>€/an</span>
                </mat-form-field>
            </div>

            <div class="col-6">
                <mat-form-field>
                    <mat-label>Charges locataire
                        <i class="fa fa-exclamation-triangle" *ngIf="favorite.lots.length > 1"
                           matTooltip="Modifier les charges par lot ci dessous"></i>
                        <i class="fa fa-info-circle" *ngIf="favorite.lots.length == 1" matTooltip="Les charges appliquées en plus du loyer sont à renseigner ici. Ces charges sont payées par votre locataire et n’ont donc pas d’impact sur votre rendement et votre cash-flow, sauf dans 2 cas :
En cas de gestion par agence : le % de commission s’applique sur le montant charges comprises du loyer. Les charges locataires augmentent donc légèrement les frais d’agence
En cas de vacance locative :  Ce sera au propriétaire de payer les charges pendant que son logement sera vacant"></i>
                    </mat-label>
                    <input type="number" step="100" matInput [(ngModel)]="favorite.amount_copro_rent"
                           (ngModelChange)="edit($event)"
                           [disabled]="favorite.lots.length > 1">
                    <span matSuffix>€/mois</span>
                </mat-form-field>
            </div>

            <div class="col-6">
                <mat-form-field>
                    <mat-label>Charges de copro (part priopriétaire)
                        <i class="fa fa-info-circle"
                           matTooltip="Montant des charges non récupérables. La liste officielle des charges récupérables sur votre locataire est disponible ici : https://www.economie.gouv.fr/particuliers/proprietaire-bailleur-charges-recuperables-locataire"></i>
                    </mat-label>
                    <input type="number" step="100" matInput [(ngModel)]="favorite.amount_copro"
                           (ngModelChange)="edit($event)">
                    <span matSuffix>€/an</span>
                </mat-form-field>
            </div>

            <div class="col-6">
                <mat-form-field>
                    <mat-label>Taxe foncière <i class="fa fa-info-circle" matTooltip="Indiquez ici le montant de la taxe foncière sans la Taxe d’Enlèvement des Ordures Ménagères (TEOM). La TEOM est récupérable dans les charges de votre locataire et doit être renseignée dans la case “Charges de copro (part locataire)”.
Par défaut, nous mettons la taxe foncière correspond à 1 mois de loyer."></i></mat-label>
                    <input type="number" step="100" matInput [(ngModel)]="favorite.amount_property_tax"
                           (ngModelChange)="edit($event)">
                    <span matSuffix>€/an</span>
                </mat-form-field>
            </div>

            <div class="col-6">
                <mat-slide-toggle class="mt-3" color="primary" [(ngModel)]="detailLot"
                                  (ngModelChange)="toogleDetailLot()">Ce projet comporte plusieurs lots
                </mat-slide-toggle>
            </div>
            <div class="col-6" *ngIf="detailLot && !splitLot">
                <mat-form-field>
                    <mat-label>Lots</mat-label>
                    <input type="number" step="1" matInput [(ngModel)]="favorite.nb_lots" (ngModelChange)="edit($event)"
                           [disabled]="favorite.lots.length > 1">
                </mat-form-field>
            </div>
            <div class="col-6" *ngIf="detailLot && !splitLot">
                <button type="button" class="btn btn-outline btn-lg w-100" (click)="splitLots()">
                    <i class="fa fa-plus"></i>
                    Séparer les lots
                </button>
            </div>

            <ng-container *ngIf="favorite.lots.length > 1">
                <div class="bg-light bloc-list row m-2 mb-3" *ngFor="let lot of favorite.lots; index as i">

                    <div class="col-11">
                        <mat-form-field>
                            <mat-label>Nom <i class="fa fa-info-circle"
                                              matTooltip="Identifiez facilement vos lots (ex: Appartement 1er étage)"></i>
                            </mat-label>
                            <input class="text" matInput [(ngModel)]="lot.title"
                                   (ngModelChange)="edit($event, 'lot.title')">
                        </mat-form-field>
                    </div>
                    <!--                    <div class="col-5">-->
                    <!--                        DPE / GES-->
                    <!--                    </div>-->

                    <div class="dropdown dropstart d-inline-block col-1">
                        <button class="btn btn-outline float-right"
                                id="dropdownFav-{{i}}" data-bs-toggle="dropdown" aria-haspopup="true"
                                aria-expanded="false">
                            <i class="fa fa-ellipsis-v"></i>
                        </button>
                        <div id="optionDropdown-{{i}}" class="dropdown-menu dropdown-menu-right"
                             aria-labelledby="dropdownFav" aria-haspopup="true" aria-expanded="false">
                            <ul class="pictoList">
                                <li>
                                    <a (click)="duplicateLot(i)">
                                        <i class="fa cfa cfa-clone"></i> Duppliquer
                                    </a>
                                </li>
                                <li class="delete">
                                    <a (click)="deleteLot(i)">
                                        <i class="fa cfa cfa-trash"></i>
                                        Supprimer
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <mat-form-field>
                            <mat-label>Superficie</mat-label>
                            <input type="number" step="10" matInput [(ngModel)]="lot.square"
                                   (ngModelChange)="edit($event, 'square')">
                            <span matSuffix>m²</span>
                        </mat-form-field>
                    </div>

                    <div class="col-md-4">
                        <mat-form-field>
                            <mat-label>Typologie</mat-label>
                            <mat-select disableOptionCentering [(ngModel)]="lot.estate_type" (ngModelChange)="edit($event)">
                                <mat-option [value]="'Maison'">Maison</mat-option>
                                <mat-option [value]="'Appartement'">Appartement</mat-option>
                                <mat-option [value]="'Chambre'">Chambre (colocation)</mat-option>
                                <mat-option [value]="'Parking'">Parking / Garage</mat-option>
                                <mat-option [value]="'Commerce'">Local commercial</mat-option>
                                <mat-option [value]="'Parties communes'">Parties communes</mat-option>
                                <mat-option [value]="'Terrain'">Terrain</mat-option>
                                <mat-option [value]="'Autres'">Autre</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-md-4">
                        <mat-form-field [hidden]="lot.estate_type !== 'Maison' && lot.estate_type !== 'Appartement'">
                            <mat-label>Nombre de pièces</mat-label>
                            <input type="number" step="1" matInput [(ngModel)]="lot.rooms" (ngModelChange)="edit($event)">
                        </mat-form-field>
                    </div>

                    <div class="col-6">
                        <mat-form-field>
                            <mat-label>Loyer hors charges<i class="fa fa-info-circle"
                                                            matTooltip="Le montant du loyer mensuel sans les charges locatives."></i>
                            </mat-label>
                            <input type="number" step="100" matInput [(ngModel)]="lot.amount_rent"
                                   (ngModelChange)="edit($event)">
                            <span matSuffix>€/mois</span>
                        </mat-form-field>
                    </div>

                    <div class="col-6">
                        <mat-form-field>
                            <mat-label>Charges locataire
                                <i class="fa fa-info-circle" matTooltip="Les charges appliquées en plus du loyer sont à renseigner ici. Ces charges sont payées par votre locataire et n’ont donc pas d’impact sur votre rendement et votre cash-flow, sauf dans 2 cas :
En cas de gestion par agence : le % de commission s’applique sur le montant charges comprises du loyer. Les charges locataires augmentent donc légèrement les frais d’agence
En cas de vacance locative :  Ce sera au propriétaire de payer les charges pendant que son logement sera vacant"></i>
                            </mat-label>
                            <input type="number" step="100" matInput [(ngModel)]="lot.amount_copro_rent"
                                   (ngModelChange)="edit($event)">
                            <span matSuffix>€/mois</span>
                        </mat-form-field>
                    </div>


                </div>

                <div class="col-md-12">
                    <button (click)="addLot()" class="btn btn-outline mt-2 w-100 mb-3 mb-md-0">
                        <i class="fa cfa cfa-plus-circle"></i><span class="libelle">Ajouter un lot</span>
                    </button>
                </div>
            </ng-container>
        </div>
    </div>
</div>
